import { useParams } from 'react-router-dom';

import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { ControlSizesMD } from '@picsart/design-system/components/helpers';

import SearchInput from 'components/SearchInput';

import { useTranslator } from '@picsart/rc/services/localization';
import categoryNameConstruct from 'utils/categoryNameConstruct';
import Content from '../Content';
import useStyles from './styles';
import { StickyFiltersProps } from './types';

const StickyFilters = ({ subCategories, headerHeight }: StickyFiltersProps) => {
  const classes = useStyles({ headerHeight });
  const translate = useTranslator();
  const { category, subCategory } = useParams();
  const { finalCategory, newCategoryPage } = categoryNameConstruct(category, subCategory);
  const title = newCategoryPage
    ? subCategory.split('-').join(' ')
    : finalCategory?.split('-').join(' ');

  return (
    <div className={classes.root} data-testid="sticky-filters">
      <HorizontalContainer className={classes.wrapper}>
        <div className={classes.left} data-testid="sticky-filters-left">
          <p className={classes.title}>{translate(title)}</p>
          <SearchInput
            placeholder={`Search for ${title} templates`}
            containerClassName={classes.searchWrapper}
            size={ControlSizesMD}
            filterType={category}
          />
        </div>
        <Content subCategories={subCategories} className={classes.contentContainer} isSticky />
      </HorizontalContainer>
    </div>
  );
};

export default StickyFilters;
